import * as React from 'react';

import {LinkDynPageCollectionPicker} from './LinkDynPageCollectionPicker';
import {LinkPreload} from './LinkPreload';
import {LinkTarget} from './LinkTarget';
import type {State} from './LinkTypes';
import {Label} from './LinkUIComponents';

export const LinkDynPageMode = ({
  state,
  dispatch,
  isOverride,
  canBindDynPage,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
  isOverride: boolean;
  canBindDynPage?: boolean;
}) => {
  return (
    <>
      {!canBindDynPage && (
        <LinkDynPageCollectionPicker
          state={state}
          dispatch={dispatch}
          isOverride={isOverride}
        />
      )}
      {/* Target */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Open in
      </Label>
      <LinkTarget state={state} dispatch={dispatch} />
      {/* Preload */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Preload
      </Label>
      <LinkPreload state={state} dispatch={dispatch} />
    </>
  );
};
